import { useState } from "react"
import { Form, Row, Col, Button } from "react-bootstrap"
import toast, { Toaster } from "react-hot-toast"
import API from "components/Apis/API"

const disabledButtonStyle = {
  opacity: 1,
  color: "white",
  backgroundColor: "#ccc",
  cursor: "not-allowed",
}

const InputFeatures = () => {
  const [formData, setFormData] = useState({
    vehicle: "",
    startLocation: "",
    endLocation: "",
    pickupDate: "",
    deliveryDate: "",
    predictedPrice: "",
    realPrice: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const makePrediction = async () => {
    toast.loading("Making Prediction...")
    const url = "admin/predict-price"
    try {
      const response = await API.postData(url, formData)
      if (response.status) {
        setFormData((prevData) => ({
          ...prevData,
          predictedPrice: response.data,
        }))
        toast.dismiss()
      } else {
        toast.dismiss()
        toast.error("Error making prediction")
      }
    } catch (error) {
      console.log(error("Error making the prediciton:", error))
      toast.error("Error making prediction")
    }
  }

  const featuresEntered = () => {
    return (
      formData.vehicle === "" ||
      formData.startLocation === "" ||
      formData.endLocation === "" ||
      formData.pickupDate === "" ||
      formData.deliveryDate === ""
    )
  }

  const isFormEmpty = () => {
    return Object.values(formData).some((value) => value === "")
  }

  const submitFeedBack = async () => {
    const url = "admin/record-prediction"
    const response = await API.postData(url, formData)
    toast.success("Feedback recorded")
  }
  return (
    <Form className='px-4'>
      <Toaster position='bottom-right' />
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>Truck Selection</Form.Label>
            <Form.Control
              as='select'
              defaultValue='Choose...'
              name='vehicle'
              onChange={handleChange}
            >
              <option>Choose...</option>
              <option>Tractor</option>
              <option>Straight Truck</option>
              <option>Cube Van</option>
              <option>Sprinter</option>
              <option>Cargo Van</option>
            </Form.Control>
          </Form.Group>
          <Form.Group>
            <Form.Label>Start Location</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter start location'
              name='startLocation'
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>End Location</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter end location'
              name='endLocation'
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Pickup Date</Form.Label>
            <Form.Control
              type='datetime-local'
              placeholder='Pickup Date'
              name='pickupDate'
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Delivery Date</Form.Label>
            <Form.Control
              type='datetime-local'
              placeholder='Delivery Date'
              name='deliveryDate'
              onChange={handleChange}
            />
          </Form.Group>
          <Button
            onClick={makePrediction}
            disabled={featuresEntered()}
            style={
              featuresEntered()
                ? { ...disabledButtonStyle }
                : { cursor: "pointer" }
            }
            className='mt-4'
          >
            Predict Price
          </Button>
        </Col>
        <Col>
          <Form.Label>Predicted price $</Form.Label>
          <Form.Control
            placeholder='Predicted Price'
            value={formData.predictedPrice}
          />
          <Form.Label>Real Price $</Form.Label>
          <Form.Control
            type='number'
            name='realPrice'
            onChange={handleChange}
            placeholder='Enter the Real Price'
          />
          <Button
            className='mt-4'
            onClick={submitFeedBack}
            disabled={isFormEmpty()}
            style={
              isFormEmpty() ? { ...disabledButtonStyle } : { cursor: "pointer" }
            }
          >
            Submit Feedback
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default InputFeatures
